export function parseCompanyLocalization(value, supportedLocales) {
  if (!value) return { localizations: {}, malformed: false };

  let parsed = value;
  if (typeof value === "string") {
    try {
      parsed = JSON.parse(value);
    } catch {
      return { localizations: {}, malformed: true };
    }
  }

  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return { localizations: {}, malformed: true };
  }

  const localizations = {};
  for (const locale of supportedLocales) {
    const translations = parsed[locale];
    if (!translations || typeof translations !== "object" || Array.isArray(translations)) continue;
    localizations[locale] = Object.fromEntries(Object.entries(translations)
      .filter(([, translation]) => typeof translation === "string" && translation.length > 0));
  }
  return { localizations, malformed: false };
}

export function cloneLocaleMessages(messages) {
  return JSON.parse(JSON.stringify(messages || {}));
}

export function mergeCompanyLocaleMessages(baseMessages, customMessages) {
  return { ...cloneLocaleMessages(baseMessages), ...(customMessages || {}) };
}
